import Chip from '../../common/ui/chip.vue'
import MenuSousMenu from '../../common/ui/menu_sous-menu.vue'
import DatesMixin from '../../common/mixins/Dates'
import Select from '../../common/forms/Select.vue'
import Input from '../../common/forms/Input.vue'

export default {
	mixins: [DatesMixin],
	data() {
		return {
			search: null,
			show: 'all',
		}
	},
	props: [],
	created(){
		
	},
	methods: {
		deleteParcelleListe(parcelle_liste){
			let self = this;
			this.$dialog.confirm(this.$t('parcelle_listes_favoris_supprimer_confirmation'), {loader: true})
			.then(dialog => {
				self.$store.dispatch('deleteParcelleListe', parcelle_liste);
				setTimeout(function(){
					dialog.close();
				}, 200);
			});
		},
		exportRapportDurabilite(parcelle_liste){
			this.$store.dispatch('open_modal', {
				code: 'export_rapport_durabilite',
				params: {
					parcelle_liste: parcelle_liste
				}
			})
		}
	},
	computed:{
		utilisateurs(){
			let utilisateurs = []
			this.$store.state.parcelle.parcelles_lists.forEach(function(recherche){
				utilisateurs.push(recherche.owner_id)
			})
			//RZ--> On supprime les doublons et on trie
			return [...new Set(utilisateurs)].sort();
		},
		utilisateurs_select(){
			let utilisateurs = []
			if(this.utilisateurs && this.utilisateurs.length){
				this.utilisateurs.forEach(function(utilisateur){
					utilisateurs.push({
						label: utilisateur,
						value: utilisateur
					})
				})
			}
			return utilisateurs
		},
		parcelle_listes(){
			let self = this
			let list = _.cloneDeep(this.$store.state.parcelle.parcelles_lists)
			let recherches = []

			//RZ--> Filtre sur l'utilisateur
			list.forEach(function(recherche){
				if(self.show == 'all' || self.show == recherche.owner_id){
					recherches.push(recherche)
				}
			})

			//RZ--> Filtre sur le nom de la recherche
			if(this.search){
				let search = String(this.search).toLowerCase()
				recherches = recherches.filter(function(recherche){
					return recherche.name ? String(recherche.name).toLowerCase().includes(search) : false
				})
			}

			return recherches.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
		},
		settings(){
			return {
				menu: {
					picto: 'Action',
					label: false,
					arrow: false,
					bg_color: '#F4F6F9',
					color: null
				},
				sousmenu: {
					class: '',
					list: [
						{
							picto: 'Trash2',
							label: this.$t('parcelle_listes_favoris_supprimer'),
							action: this.deleteParcelleListe,
							viewBox: '0 0 24 24',
							width: 18,
							height: 18
						}
					]
				}
			}
		},
		menu_download(){
			return {
				menu: {
					picto: 'Download2',
					label: false,
					arrow: false,
					bg_color: '#F4F6F9',
					color: null,
					viewBox: '0 0 24 24',
				},
				sousmenu: {
					class: '',
					list: [
						{
							picto: 'Download2',
							label: this.$t('parcelle_listes_export_rapport_durabilite'),
							action: this.exportRapportDurabilite,
							viewBox: '0 0 24 24',
							width: 18,
							height: 18
						}
					]
				}
			}
		}
	},
	components:{
		Chip,
		MenuSousMenu,
		Input,
		Select
	}
}